// Material
import { Typography } from '@mui/material'
import { t } from '$i18n'
import { dateTimeFormatter } from '$func/time'

interface Props {
  joinedAt: number
}

export function MemberJoiningDateStatus({ joinedAt }: Props) {
  const statusText = `${t(
    'addMembers.joinedAt.prefix',
  )} ${dateTimeFormatter.format(new Date(joinedAt))} ${t(
    'addMembers.joinedAt.postfix',
  )}`

  return (
    <Typography variant="caption1" sx={{ color: 'primary.main' }}>
      {statusText}
    </Typography>
  )
}
